import React from "react";
import PropTypes from "prop-types";
import { BaseIcon } from "./style";
import { SIZE, ICON_ANIMATION_TYPE } from "constant";

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  bgColor: PropTypes.string,
  hoverColor: PropTypes.string,
  size: PropTypes.oneOf([
    SIZE.xxs,
    SIZE.xs,
    SIZE.small,
    SIZE.medium,
    SIZE.large,
    SIZE.xl,
    SIZE.xxl,
    SIZE._3xl,
    SIZE._4xl,
    SIZE._4xlh,
    SIZE._5xl,
    SIZE._6xl,
    SIZE._7xl,
  ]),
  onClick: PropTypes.func,
  animationType: PropTypes.oneOf(Object.values(ICON_ANIMATION_TYPE)),
};
Icon.defaultProps = {
  color: "inherit",
  size: SIZE.medium,
};

function Icon(props) {
  let fontSize;
  let padding;
  let animationType = props.animationType
    ? "pl-" + props.animationType + " 1s infinite linear"
    : "none";

  switch (props.size) {
    case SIZE.xxs:
      fontSize = 10;
      padding = 3;
      break;
    case SIZE.xs:
      fontSize = 12;
      padding = 4;
      break;
    case SIZE.small:
      fontSize = 14;
      padding = 5;
      break;
    case SIZE.medium:
      fontSize = 15;
      padding = 6;
      break;
    case SIZE.large:
      fontSize = 16;
      padding = 6;
      break;
    case SIZE.xl:
      fontSize = 18;
      padding = 7;
      break;
    case SIZE.xxl:
      fontSize = 20;
      padding = 8;
      break;
    case SIZE._3xl:
      fontSize = 24;
      padding = 8;
      break;
    case SIZE._4xl:
      fontSize = 28;
      padding = 10;
      break;
    case SIZE._4xlh:
      fontSize = 28;
      padding = 14;
      break;
    case SIZE._5xl:
      fontSize = 32;
      padding = 10;
      break;
    case SIZE._6xl:
      fontSize = 40;
      padding = 12;
      break;
    case SIZE._7xl:
      fontSize = 48;
      padding = 14;
      break;
    default:
      fontSize = null;
      padding = 0;
      break;
  }

  return (
    <BaseIcon
      className={"icon icon-" + props.name}
      fontSize={fontSize}
      color={props.color}
      cursor={props.onClick ? "pointer" : "inherit"}
      onClick={props.onClick}
      hoverColor={props.hoverColor}
      animationName={animationType}
      bgColor={props.bgColor}
      padding={props.bgColor ? padding : 0}
    />
  );
}

export default Icon;
